import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Form, Button, Container, Alert } from "react-bootstrap";
import axios from "axios";

const UpdatePayment = () => {
  const { state } = useLocation();
  const orderId = state?.order_id;
  const customerId = state?.customer_id;
  const payment_id = state?.payment_id;

  const grandTotal = parseFloat(state?.grand_total || 0);

  const [discount, setDiscount] = useState(0);
  const [amount, setAmount] = useState(0); // ✅ Start with 0, optional
  const [paymentMethod, setPaymentMethod] = useState("");
  const [totalPaid, setTotalPaid] = useState(0);
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");

  const discountValue = parseFloat(discount || 0);
  const paidNow = parseFloat(amount || 0);
  const requiredTotal = grandTotal - discountValue;
  const remainingBalance = requiredTotal - totalPaid;


  const handleSubmit = async (e) => {
    e.preventDefault();
    setSuccess("");
    setError("");

    const newTotalPaid = totalPaid + paidNow;

    if (paidNow > remainingBalance) {
      setError(
        `Amount cannot exceed remaining balance of $${remainingBalance.toFixed(2)}.`
      );
      return;
    }

    // ✅ Dynamically determine payment status
    let paymentStatus = "unpaid";
    if (newTotalPaid === 0) {
      paymentStatus = "unpaid";
    } else if (newTotalPaid >= requiredTotal) {
      paymentStatus = "paid";
    } else {
      paymentStatus = "partial paid";
    }
    const API_BASE = process.env.REACT_APP_API_BASE_URL;

    try {
      const token = localStorage.getItem("admin_token");
      const res = await axios.put(
        `${API_BASE}/api/payments/update/${payment_id}`,
        {
          order_id: orderId,
          customer_id: customerId,
          amount: paidNow,
          discount: discountValue,
          payment_method: paymentMethod,
          payment_status: paymentStatus,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      setSuccess(res.data.message || "Payment updated successfully.");
      setAmount(0); // ✅ Reset to 0
    } catch (err) {
      setError("Failed to update payment.");
      console.error("Payment update error:", err);
    }
  };

  return (
    <Container className="mt-4">
      <h3>Update Payment for Order #{orderId}</h3>

      <Alert variant="info">
        Grand Total: ${grandTotal.toFixed(2)} <br />
        Discount: ${discountValue.toFixed(2)} <br />
        Already Paid: ${totalPaid.toFixed(2)} <br />
        <strong>Remaining Balance: ${remainingBalance.toFixed(2)}</strong>
      </Alert>

      {success && <Alert variant="success">{success}</Alert>}
      {error && <Alert variant="danger">{error}</Alert>}

      <Form onSubmit={handleSubmit}>
        <Form.Group className="mb-3">
          <Form.Label>Discount</Form.Label>
          <Form.Control
            type="number"
            step="0.01"
            value={discount}
            onChange={(e) => setDiscount(e.target.value)}
            placeholder="0.00"
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Amount Paid</Form.Label>
          <Form.Control
            type="number"
            step="0.01"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
            placeholder="0.00"
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Payment Method</Form.Label>
          <Form.Select
            value={paymentMethod}
            onChange={(e) => setPaymentMethod(e.target.value)}
            required
          >
            <option value="">--Select--</option>
            <option value="Cash">Cash</option>
            <option value="Card">Card</option>
            <option value="Online">Online</option>
          </Form.Select>
        </Form.Group>

        <Button type="submit">Submit Payment</Button>
      </Form>
    </Container>
  );
};

export default UpdatePayment;
